import s from "./Header.module.css";

const Header = () => {
  return (
    <div>
      <h1 className={s.title}>K i m o j i - G a c h a</h1>
    </div>
  );
};

export { Header };
